import { FilteredFaQsBySlugDocument } from "./../graphql/FAQs.mjs";
import { useCachedSsrRef } from "./serverCache.mjs";
import { useSetLocaleToCacheParams } from "./i18n.mjs";
import {
  AllFaQsDocument,
  FaQsCategoriesDocument,
  FilteredFaQsDocument
} from "../graphql/FAQs.mjs";
import { useQuery } from "villus";
const CACHE_TTL = 1e3 * 60 * 1;
export async function useFAQsCategories() {
  const { cacheParam } = useSetLocaleToCacheParams();
  const categories = useCachedSsrRef(
    cacheParam("FAQsCategories"),
    [],
    CACHE_TTL
  );
  const { execute } = useQuery({
    query: FaQsCategoriesDocument,
    cachePolicy: "network-only",
    fetchOnMount: false
  });
  if (!categories.value.length) {
    const { data, error } = await execute();
    if (error) {
      throw new Error(error.message);
    }
    categories.value = data?.categories || [];
  }
  return categories.value;
}
export async function useAllFAQs() {
  const { cacheParam } = useSetLocaleToCacheParams();
  const allQuestions = useCachedSsrRef(
    cacheParam("AllFaQs"),
    [],
    CACHE_TTL
  );
  const { execute } = useQuery({
    query: AllFaQsDocument,
    cachePolicy: "network-only",
    fetchOnMount: false
  });
  if (!(allQuestions.value?.length && allQuestions.value[0])) {
    const { data, error } = await execute();
    if (error) {
      throw new Error(error.message);
    }
    allQuestions.value = data?.allQuestions || [];
  }
  return allQuestions;
}
export function useFilteredFAQs() {
  const { execute, isFetching } = useQuery({
    query: FilteredFaQsDocument,
    cachePolicy: "network-only",
    fetchOnMount: false
  });
  async function fetchFilteredFAQs(categoryId) {
    const { data, error } = await execute({
      variables: { categoryId }
    });
    if (error) {
      throw new Error(error.message);
    }
    return data?.allQuestions || [];
  }
  return { fetchFilteredFAQs, isFetching };
}
export function useFilteredFAQsBySlug() {
  const { execute, isFetching } = useQuery({
    query: FilteredFaQsBySlugDocument,
    cachePolicy: "network-only",
    fetchOnMount: false
  });
  async function fetchFilteredFaqBySlug(slug) {
    const { data, error } = await execute({
      variables: { slug }
    });
    if (error) {
      throw new Error(error.message);
    }
    return data?.allQuestions || [];
  }
  return { fetchFilteredFaqBySlug, isFetching };
}
